/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Button, Grid, IconButton, Typography2, breakpoints } from '@coursera/cds-core';

type CtaButtonProps = {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
};

type Props = {
  headerText: string;
  bodyText: string;
  isDismissed: boolean;
  onDismiss: () => void;
  ctaButton: CtaButtonProps;
};

const styles = {
  bannerContainer: css`
    border-radius: var(--cds-spacing-200);
    border: 2px solid var(--cds-color-grey-50);
    background: var(--cds-color-emphasis-primary-background-xweak);

    &.cds-grid-item {
      padding: var(--cds-spacing-150) var(--cds-spacing-300);
    }

    ${breakpoints.down('sm')} {
      &.cds-grid-item {
        padding: var(--cds-spacing-200);
      }
    }
  `,
  button: css`
    ${breakpoints.down('sm')} {
      padding: 0;
    }
  `,
  closeButton: css`
    svg {
      color: var(--cds-color-neutral-primary);

      ${breakpoints.down('sm')} {
        align-self: flex-start;
      }
    }
  `,
};

const InferredRoleBanner = ({ isDismissed, onDismiss, ctaButton, headerText, bodyText }: Props) => {
  if (isDismissed) {
    return null;
  }

  const { label, onClick, isLoading } = ctaButton;

  return (
    <Grid container item xs={12} css={styles.bannerContainer}>
      <Grid item xs container spacing={8} alignItems="center">
        <Grid item sm={12} md="auto">
          <Typography2 variant="subtitleMedium" component="h2">
            {headerText}
          </Typography2>
        </Grid>
        <Grid item sm={12} md="auto">
          <Typography2 variant="bodyPrimary" component="p">
            {bodyText}
          </Typography2>
        </Grid>
        <Grid item sm={12} md="auto">
          <Button css={styles.button} variant="ghost" size="small" onClick={onClick} loading={isLoading}>
            {label}
          </Button>
        </Grid>
      </Grid>
      <Grid item xs="auto" css={styles.closeButton}>
        <IconButton size="small" intent="close" variant="ghost" onClick={onDismiss} />
      </Grid>
    </Grid>
  );
};

export default InferredRoleBanner;
